export class RectangleF {
  public static DEFAULT = new RectangleF(0, 0, 1, 1);
  constructor(
    public x: number,
    public y: number,
    public width: number,
    public height: number,
  ) {}

  public validateBorders(): boolean {
    return this.x + this.width <= 1 && this.y + this.height <= 1;
  }
}
